import { selectors } from './config';

export default class Tooltip {
  disabled = false;

  container;
  closeButton;

  constructor(containerEl) {
    this.container = containerEl;
    this.closeButton = containerEl.querySelector(selectors.tooltip.closeButton);
    this.textContainer = containerEl.querySelector(
      selectors.tooltip.textContainer,
    );

    this.attachListeners();
  }

  disable() {
    this.close();
    this.disabled = true;
  }

  show() {
    if (this.disabled) return;

    this.container.ariaHidden = false;
  }

  close() {
    if (this.disabled) return;

    this.container.ariaHidden = true;
  }

  setText(text) {
    this.textContainer.textContent = text;
  }

  isClosed() {
    return this.container.dataset.closed === 'true';
  }

  attachListeners() {
    this.closeButton.addEventListener('click', () => {
      this.close();
    });
  }
}
